import Vue from 'vue';

export default Vue.filter('json', function (value: any) {
    return JSON.stringify(value);
});